import { useFirstPaymentDateField } from '../../../../baseDealActivity/baseDealContainer/hooks/useFirstPaymentDateField';
import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const FirstPaymentDateRow = () => {
    const { label, value } = useFirstPaymentDateField();

    return (
        <ReadOnlyValueRow
            rowKey="firstPaymentDate"
            label={label}
            value={value}
            labelTestId="summary-tab-first-payment-date-label"
            valueTestId="summary-tab-first-payment-date"
        />
    );
};
